import axios from "axios";
import store from "../../redux/store";
import * as actions from "./DashboardType";
import { handleAxiosGet } from "../axiosHelper";


export const getDashboardValue = async (paramValues) => {
  const endPoint = `/api/dashboard/getDashboardValue/${paramValues}`;
   const { data: responseData } = await handleAxiosGet(endPoint);

  if (responseData) {
    store.dispatch({
      type: actions.SETDASHBOARDVALUE,
      payload: { list: responseData },
    });

    return responseData;
  } else {
    return responseData;
  }
};

export const getDashboardCount = async (paramValues) => {
  const endPoint = `/api/dashboard/getDashboardCount/${paramValues}`;
  const { data: responseData } = await handleAxiosGet(endPoint);

  if (responseData) {
    store.dispatch({   
      type: actions.SETDASHBOARDCOUNT,
       payload: { list: responseData },
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const getDashboardOutstanding = async (paramValues) => {
  const endPoint = `/api/dashboard/getDashboardOutstanding/${paramValues}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SETDASHBOARDOUTSTANDING,
     payload: { list: responseData },
    });
    return responseData;
  } else {
    return responseData;
  }
};

export const getDashboardTopOutstandingCustomer = async (paramValues) => {
  const endPoint = `/api/dashboard/getDashboardTopOutstandingCustomer/${paramValues}`;
 const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SETDASHBOARDTOPOUTSTANDINGCUSTOMER,
      payload: { list: responseData },
    });

    return responseData;
  } else {
    return responseData;
  }
};


